<div class="mobile-menu">
  <div class="mobile-menu-header">
    <h3 class="mobile-menu-title">{{this.word[this.language].zavedeniaBG}}</h3>
    <button class="close-button" (click)="close()"><i class="fa fa-times"></i></button>
  </div>
  <div class="mobile-menu-body">
    <ul>
      <li>
        <a (click)="closeWithLink()" [routerLink]="['/']"><i class="fa fa-home"></i>&nbsp;
          {{this.word[this.language].home}}</a>
      </li>
      <li *ngIf="!isOutside" class="with-dropdown">
        <button (click)="toggleDropDown()"><i class="fa fa-building-o"></i> {{this.word[this.language].chooseCity}}&nbsp; <i
            class="fa fa-caret-down" aria-hidden="true"></i></button>
        <ul class="sub-menu">
          <li class="sub-menu-link">
            <a href="http://sofia.{{getHost()}}/"
              title="{{this.word[this.language].sofia}}, {{this.word[this.language].venues}}">
              {{this.word[this.language].sofia}}</a>
          </li>
          <li class="sub-menu-link">
            <a href="http://plovdiv.{{getHost()}}/"
              title="{{this.word[this.language].plovdiv}}, {{this.word[this.language].venues}}">
              {{this.word[this.language].plovdiv}}</a>
          </li>
          <li class="sub-menu-link">
            <a href="http://varna.{{getHost()}}/"
              title="{{this.word[this.language].varna}}, {{this.word[this.language].venues}}">
              {{this.word[this.language].varna}}</a>
          </li>
          <li class="sub-menu-link">
            <a href="http://burgas.{{getHost()}}/"
              title="{{this.word[this.language].burgas}}, {{this.word[this.language].venues}}">
              {{this.word[this.language].burgas}}</a>
          </li>
          <li class="sub-menu-link">
            <a href="http://tarnovo.{{getHost()}}/"
              title="{{this.word[this.language].tarnovo}}, {{this.word[this.language].venues}}">
              {{this.word[this.language].tarnovo}}</a>
          </li>
          <li class="sub-menu-link">
            <a href="http://bansko.{{getHost()}}/"
              title="{{this.word[this.language].bansko}}, {{this.word[this.language].venues}}">
              {{this.word[this.language].bansko}}</a>
          </li>
          <li class="sub-menu-link">
            <a href="http://bulgaria.zavedenia.com/"
              title="{{this.word[this.language].others}}, {{this.word[this.language].venues}}">
              {{this.word[this.language].others}}</a>
          </li>
        </ul>
      </li>
      <li>
        <a (click)="closeWithLink()" [routerLink]="['/', 'categories']"><i class="fa fa-list-alt"></i>&nbsp;
          {{this.word[this.language].venueCategories}}</a>
      </li>
      <!-- <li>
        dev
        <a (click)="closeWithLink(2)"><i class="fa fa-star"></i>&nbsp; {{this.word[this.language].topVenues}}</a>
      </li> -->
      <!-- <li>
        <a (click)="closeWithLink(3)"><i class="fa fa-percent"></i>&nbsp; {{this.word[this.language].offers}}</a>
      </li> -->
      <!-- <li>
        <a (click)="closeWithLink(4)"><i class="fa fa-newspaper-o"></i>&nbsp; {{this.word[this.language].news}}</a>
      </li> -->
      <li>
        <a href="https://{{city}}.programa.bg" rel="noopener" target="_blank"><i class="fa fa-calendar"></i>&nbsp;
          {{this.word[this.language].program}}</a>
      </li>
      <li>
        <a href="https://partypeople.bg" rel="noopener" target="_blank"><i class="fa fa-picture-o"></i>&nbsp;
          {{this.word[this.language].partyPeople}}</a>
      </li>
      <li>
        <a (click)="closeWithLink()" [routerLink]="['/', 'page', 'contacts']"><i class="fa fa-info-circle"></i>&nbsp;
          {{this.word[this.language].contacts}}</a>
      </li>
      <li>

        <button id="language-text" (click)="changeLanguage()"><i class="fa fa-globe" aria-hidden="true"></i>
          {{this.translationService.language == 'en' ? 'BG' : 'EN'}}</button>
      </li>
      <!-- <li>
        <a (click)="closeWithLink()"><i class="fa fa-globe" aria-hidden="true"></i>&nbsp;
          {{this.word[this.language].changeLang}}</a>
        <a (click)="closeWithLink()"><i class="fa fa-globe" aria-hidden="true"></i>&nbsp;
          {{this.word[this.language].changeLangBG}}</a>
      </li> -->
      <li>
        <a target="_blank" href="http://login.zavedenia.com/login"><i class="fa fa-sign-in"></i>&nbsp;
          {{this.word[this.language].ownersLogin}}</a>
      </li>
    </ul>
  </div>
</div>
<div class="mobile-menu-backdrop in" (click)="close()">
</div>
